@if (getBets() | async; as bets) {
    <div>
        @if (bets.length > 0) {
            <div
                id="betslip-dialog"
                class="d-flex justify-content-center align-items-center rounded-circle"
                data-bs-toggle="modal"
                data-bs-target="#bets-modal">
                <div>
                    <span class="text-white position-absolute end-0">
                        {{ bets.length }}
                    </span>
                    @if (!displayIcon(bets)) {
                        <p class="text-white fw-semibold m-0">
                            {{ calculateTotalOdds(bets) }}
                        </p>
                    } @else {
                        <i class="bi bi-receipt fs-5 text-white"></i>
                    }
                </div>
            </div>
        }
    </div>
}
<div
    class="modal fade bottom-sheet"
    id="bets-modal"
    tabindex="-1"
    aria-labelledby="betspLabel"
    aria-hidden="true"
    (hidden.bs.modal)="closeModal()">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body p-0">
                @if (isMobile) {
                    <app-bet-slip>
                        @if (getBalance()) {
                            <div
                                class="d-flex flex-column balance-section"
                                slot="balance">
                                <span>{{ 'header_menu.balance' | transloco }}</span>
                                <span class="balance-value">
                                    {{ localCurrency() }}{{ getBalance() }}
                                </span>
                            </div>
                        }
                        <i
                            class="bi bi-chevron-down fw-semibold mx-3"
                            slot="close-modal-button"
                            data-bs-dismiss="modal"
                            id="close-bet-modal"
                            (click)="closeModal()"></i>
                    </app-bet-slip>
                    <i
                        class="bi bi-chevron-down fw-semibold mx-3"
                        slot="close-modal-button-hidden"
                        data-bs-dismiss="modal"
                        id="close-bet-modal-hidden"
                        (click)="closeModal()"></i>
                }
            </div>
        </div>
    </div>
</div>
